import { colors } from '@amazd/common/static';
import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  trigger: {
    padding: 0,
  },
  container: {
    background: colors.grey20,
    width: 362,
    paddingRight: 28,
  },
  image: {
    width: 140,
  },
  text: {
    marginTop: 32,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  title: {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '22px',
    color: colors.black,
  },
  subitle: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    color: colors.grey70,
  },
}));
